/**
 * 能耗统计接口域名的统一管理
 */
const nhtj = {
  getQuantity: "/api/getQuantity", //查询统计量
  getQuantity2: "/api/getQuantity2", //查询多组统计量
  getEnergySpaceAnalysis: "/api/getEnergySpaceAnalysis",
  getEnergyCostAnalysis: "/api/getEnergyCostAnalysis",
  getEnergyCheckAnalysis: "/api/getEnergyCheckAnalysis",
  downloadEnergySpaceAnalysis: "/api/downloadEnergySpaceAnalysis",
  downloadEnergyCostAnalysis: "/api/downloadEnergyCostAnalysis",
  downloadEnergyCheckAnalysis: "/api/downloadEnergyCheckAnalysis",
  getReportGroups: "/api/getReportGroups",
  createReportGroup: "/api/createReportGroup",
  modifyReportGroup: "/api/modifyReportGroup",
  deleteReportGroup: "/api/deleteReportGroup",
  listReport: "/api/listReport",
  getReportAutomaticGeneratingConfigs:
    "/api/getReportAutomaticGeneratingConfigs",
  testReportByConfig: "/api/testReportByConfig",
  getConfigsByModelAndGroup: "/api/getConfigsByModelAndGroup",
  getAllDemandByOrg: "/api/getAllDemandByOrg",
  getDemandScheme: "/api/getDemandScheme",
  getPointedDemandSchemeInfo: "/api/getPointedDemandSchemeInfo",
  saveDemandScheme: "/api/saveDemandScheme",
  deleteDemandScheme: "/api/deleteDemandScheme",
  setPointedScheme: "/api/setPointedScheme",
  getCapacitySum: "/api/getCapacitySum",
  addReportAutomaticGeneratingConfig:'/api/addReportAutomaticGeneratingConfig',
  modifyReportAutomaticGeneratingConfig:'/api/modifyReportAutomaticGeneratingConfig',
  deleteReportAutomaticGeneratingConfig:'/api/deleteReportAutomaticGeneratingConfig'
};

export default nhtj;
